import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../../../assets/svg/ZookeeperLogo.svg";
import logoWhite from "../../../../assets/svg/ZookeeperLogoWhite.svg";
import LanguageSwitcher from "../../../../components/LanguageSwitcher";
import ThemeButton from "../../../../components/buttons/ThemeButton";
import LinkTo from "../../../../components/wrappers/LinkTo";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { DARK_BLUE } from "../../../../enums/Colors";
import { LOGIN } from "../../../../enums/UrlPaths";
import { useIsMobile } from "../../../../utils/Functions";

export default function AuthFooter() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { mode } = useContext(ThemeContext);
  const setLogo = mode == "dark" ? logo : logoWhite;
  const bgcolor = mode == "dark" ? "transparent" : DARK_BLUE;

  function GridContainer({ children }) {
    return (
      <Grid item xs={12} sm={12} md={6}>
        <Stack
          alignItems={"center"}
          justifyContent={"center"}
          height={"100%"}
          direction={"row"}
        >
          {children}
        </Stack>
      </Grid>
    );
  }
  return (
    <Paper
      sx={{
        bottom: 0,
        width: "100%",
        border: "none",
        bgcolor: bgcolor,
      }}
      component="footer"
      square
      variant="outlined"
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center">
          <GridContainer>
            <Typography color={"secondary"}>{t("Theme")}</Typography>
            <ThemeButton color={"secondary"} />
          </GridContainer>
          <GridContainer>
            <Typography variant="caption" color="white">
              {t("PowerdByKilobyte")}
            </Typography>
          </GridContainer>
          <GridContainer>
            <LanguageSwitcher />
          </GridContainer>
          <GridContainer>
            <Box sx={{ margin: 3 }}>
              <LinkTo to={LOGIN}>
                <img src={setLogo} width={250} />
              </LinkTo>
            </Box>
          </GridContainer>
        </Grid>
      </Container>
    </Paper>
  );
}
